import { useEffect, useRef } from 'react';
export var useEscapeClickaway = function useEscapeClickaway(onEscape, onClickAway) {
  var ref = useRef(null);
  useEffect(function () {
    var handleClickAway = function handleClickAway(event) {
      var el = ref.current;
      if (event.target instanceof Element && el && !el.contains(event.target)) {
        onClickAway();
      }
    };
    var handleKeydown = function handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        onEscape();
      }
    };

    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('mousedown', handleClickAway);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('keydown', handleKeydown);
    return function () {
      // Ignored via go/ees005
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      document.removeEventListener('mousedown', handleClickAway);
      // Ignored via go/ees005
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [onClickAway, onEscape]);
  return ref;
};